import '@babel/polyfill'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Print from '@/utils/print.js'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Quill from 'quill' // 引入编辑器
// 自定义字体大小
const Size = Quill.import('attributors/style/size')
// Size.whitelist = ['10px', '12px', '16px', '18px', '20px', '30px', '32px']
Size.whitelist = ['12px', '14px','16px', '18px', '20px', '22px', '24px', '26px', '28px','30px']
Quill.register(Size, true)

// 自定义字体类型
var fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'sans-serif']
var Font = Quill.import('formats/font')
Font.whitelist = fonts
Quill.register(Font, true)
Vue.use(Print) // 打印
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.component('el-input', {
  extends: ElementUI .Input,
  created() {
    this.$on('change', (value) => {
      this.$emit('input', value.replace(/\s+/g,""))
    })
  }
})
Vue.use(VueQuillEditor, /* { 默认全局 } */)
//引入自定义指令，方便全局使用
import myDirective from '@/utils/myDirective.js';
Vue.use(myDirective);
// 1.设置v-throttle自定义指令
Vue.directive('throttle', {
  bind: (el, binding) => {
    let throttleTime = binding.value // 防抖时间
    if (!throttleTime) { // 用户若不设置防抖时间，则默认2s
      throttleTime = 2000
    }
    let cbFun
    el.addEventListener('click', event => {
      if (!cbFun) { // 第一次执行
        cbFun = setTimeout(() => {
          cbFun = null
        }, throttleTime)
      } else {
        event && event.stopImmediatePropagation()
      }
    }, true)
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
